module.exports = __webpack_public_path__ + "static/media/home-bag@2x.79bdb0c5.gif";